export default __webpack_public_path__ + "static/media/post-suvinil8.c89f01a0.png";